import CoordinatorsBox from './CoordinatorsBox.vue';
export default CoordinatorsBox;


// WEBPACK FOOTER //
// ./src/components/parts/footer/coordinators/index.ts